import React from "react";

import { personasActions } from '../actions';


import { connect } from 'react-redux'

import { PersonasBadge } from '../components/PersonasBadge';
import { RelativesCard } from '../components/RelativesCard';
import { PersonaDataCard } from '../components/PersonaDataCard';
import { Spinner } from 'components/Icons/Spinner';
import { Row, Col, Modal, ModalBody } from "reactstrap";
import UploadImageCard from '../components/UploadImageCard';


var viewActions = require ('store/view.actions');

class MyProfile extends React.Component {

  componentDidMount() {
    this.props.getRelatives(this.props.token,  this.props.user.persona_id )
    this.props.setMainTitle("Mis Datos", [] )
  }

  constructor(props) {
    super(props);
    this.state = {
      modalOpen : false 
    }
 }

 setModalOpen = ( val ) => {
   this.setState( {modalOpen: val })
 }
 
//  handleInputChange = (event) => {
//   this.setState({ formData : { ...this.state.formData, [event.target.name]: event.target.value} });
// }


  render() {
    return (
      <>
            <Modal toggle={() => this.setModalOpen(!this.state.modalOpen)} isOpen={this.state.modalOpen}  size="lg">
                <ModalBody >
                    <UploadImageCard  
                      persona={this.props.user} 
                      cancel={() => this.setModalOpen(!this.state.modalOpen)} 
                      isMyProfile={true}
                      updatePersona={this.props.updatePersona}
                    />
                </ModalBody>
            </Modal>


        <div className="content">
        {!this.props.view.loadingModules.getStudentBrief ?
          <Row>
            <Col md="4">
              <PersonasBadge 
                persona={this.props.user}
                uploadImage={this.setModalOpen}
              />

              <RelativesCard
                personaID={this.props.user.persona_id}
                relatives={this.props.relatives} 
                isMyProfile={true}
                removeRelated= {this.props.deleteRelatedRelation}
                addRelated = {this.props.addRelatedRelation}
              />
              
            </Col>
            <Col md="8">
                <PersonaDataCard 
                  token= {this.props.token}
                  persona={this.props.user}
                  updatePersona={this.props.updatePersona}
                  isSaving={this.props.view.loadingModules.savingPersonaDataCard}
                  isMyProfile={true}
                />
                 
                {/* <ProfileImages 
                  images={this.props.student.persona && this.props.student.persona.images} 
                  current={this.props.student.persona && this.props.student.persona.image}
                  setCurrent={this.props.setCurrentProfileImage}
                  remove={this.props.removeProfileImage}
                  token={this.props.token}
                  /> */}
            </Col>
            
          </Row>
        :
        <Spinner size="XL" />
      }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        user: state.auth.session.user,
        relatives: state.personas.relatives,
        view: state.view
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getRelatives: (token, personaID ) => {
          dispatch(personasActions.getRelatives(token, personaID ));
        },
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        updatePersona: (token, personaID , data, isMyProfile) => {
          dispatch(personasActions.updatePersona(token, personaID , data, isMyProfile ));
        },
        deleteRelatedRelation: ( token, studentID, relatedID, isMyProfile ) => {
          dispatch(personasActions.deleteRelatedRelation(token, studentID, relatedID, isMyProfile ));
        },
        addRelatedRelation: ( token, studentID, relatedID, relationType, isMyProfile,rel  ) => {
          dispatch(personasActions.addRelatedRelation(token, studentID, relatedID, relationType, isMyProfile, rel ));
        }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);

